// extracted by mini-css-extract-plugin
export default {"box":"HomeHeader_box__E+8d9"};